export default "__VITE_ASSET__BmWgJRUw__"